export default __webpack_public_path__ + "static/media/checked.7e3cf508.svg";